import React, { Component } from "react";
import "../component/Landing.css"
import Logo from "../image/Logo.png"
// import Icon from "../image/icons.png"
import { IoSearch } from "react-icons/io5";
import { VscTriangleDown } from "react-icons/vsc";
import { FaTimes } from "react-icons/fa";
// import { RiMapPinUserFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import { FiMenu } from "react-icons/fi";



class LandingHeader extends Component {
    state = {
        search: [
            { name: "GIS", id: "1" },
            { name: "Drone", id: "2" },
            { name: "Remote Sensing", id: "3" },
            { name: "Survey", id: "4" },
            { name: "Blog", id: "5" }
        ],
        item: "All Courses",
        selectedItem: "",
        isLargeScreen: window.innerWidth > 1000,
        searchpromps: this.props.search || "",
        accessToken: ""
    }
    handledisplay = (e) => {
        e.preventDefault()
        const dropdown = document.getElementById("select_search")
        dropdown.style.display = dropdown.style.display === "block" ? "none" : "block";

    }
    handleFormDisplay = (e) => {
        e.preventDefault()
        const dropdown = document.getElementById("form_display")
        const dropdowns = document.getElementById("select_search")
        dropdowns.style.display = "block";
        dropdown.style.display = "block";

    }
    handlecollaps = (e) => {
        e.preventDefault()
        const dropdown = document.getElementById("form_display")
        const dropdowns = document.getElementById("select_search")
        dropdowns.style.display = "none";
        dropdown.style.display = "none";
    }

    handleSearchItem = (e) => {
        e.preventDefault();
        const itemName = e.target.innerText; // Get the clicked item's name

        this.setState(
            {
                item: itemName,
                selectedItem: itemName,
                searchpromps: itemName, // Set searchpromps with the clicked item's name
            },
            () => {
                // After state is updated, call handleSubmit
                this.handleSubmit({ preventDefault: () => { } }); // Call handleSubmit with a mock event
            }
        );
    };
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        const storedUser = localStorage.getItem('accessToken');
        this.setState({
            accessToken: storedUser || ""
        });
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        this.setState({ isLargeScreen: window.innerWidth > 1000 });
    };
    handleInputChange = (event) => {
        this.setState({ searchpromps: event.target.value });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.prompt(this.state.searchpromps)
        // this.setState({searchpromps: ""})
    }


    handlemenudisplay = () => {
        const menu = document.querySelector(".menudrop")
        menu.style.display = menu.style.display === "block" ? "none" : "block";
    }
    handlemenudisplay1 = () => {
        const menu = document.querySelector(".menudrop.hide")
        menu.style.display = menu.style.display === "block" ? "none" : "block";
    }
    render() {
        const search_list = this.state.search
        const search = search_list.length ?
            search_list.map(list => {
                return (
                    <li className="item" key={list.id}><button className={this.state.selectedItem === list.name ? "active" : "search_item"} onClick={this.handleSearchItem}>{list.name}</button> </li>
                )
            }) : (<li>Reload</li>)
        const search_display = this.state.item
        return (
            <header className="landing_head">
                <Link to="/"><img src={Logo} alt="company logo" className="logo" />
                    <h2 className="company_name">GEOINFOTECH <br />
                        <span>ACADEMY</span></h2></Link>
                <form className="search_form" id="form_display" style={{ display: this.state.isLargeScreen ? 'block' : 'none' }} onSubmit={this.handleSubmit}>

                    <section className="form_label">
                        <button className="selected_label" onMouseDown={this.handledisplay}> {search_display}<VscTriangleDown /> </button>
                        <section className="select_search" id="select_search">
                            {search}
                        </section>
                        <button className="cancle_search" onClick={this.handlecollaps} ><FaTimes /></button>
                    </section>
                    <input className="form_input" type="text" name="searchpromps" id="searchpromps" value={this.state.searchpromps} onChange={this.handleInputChange} placeholder="Search Course, Blog, or Webinar" required />
                    <button className="cancle_search_sub" onClick={this.handlecollaps} ><FaTimes /></button>
                    <button className="form_button" type="submit"><IoSearch /> <span>Search</span></button>
                </form>
                <nav className="search"><button className="display_search" onClick={this.handleFormDisplay}><IoSearch />Search skills, subject, or software</button></nav>
                {this.state.accessToken === "" ?
                    <>
                        <Link to="/blog"><button className="register">View Blogs</button></Link>


                        <div className="account-drop">
                            <button className="register blue" onClick={this.handlemenudisplay}>Account</button>
                            <div className="menudrop">
                                <h3>Welcome To Geoinfotech Academy</h3>
                                {this.state.accessToken === "" ?
                                    <>
                                        <Link to="/login"><li><button className="register menu">Login</button></li></Link>
                                        <Link to="/sign_up"><li><button className="register blue menu">Sign Up</button></li></Link>
                                    </> :
                                    <Link to="/dashboard"><li><button className="register blue menu">Dashboard</button></li></Link>}
                                <li>By signing up, you will have access to all our course and have the opportunity to to interact with facilitator </li>
                                <Link to="/landing_course"><li><button className="register menu">View Courses</button></li></Link>
                            </div>
                        </div>


                                    


                    </> :
                    <>
                    <Link to="/blog"><button className="register ">View Blogs</button></Link>
                    <Link to="/dashboard"><button className="register blue ">Dashboard</button></Link>

                    </>
                }
                <div className="dropdown hide"><button className="icon" onClick={this.handlemenudisplay1}><FiMenu />
                    {/* <RiMapPinUserFill /> */}
                </button>
                    <div className="menudrop hide">
                        <h3>Welcome To Geoinfotech Academy</h3>
                        {this.state.accessToken === "" ?
                            <>
                                <Link to="/login"><li><button className="register menu">Login</button></li></Link>
                                <Link to="/sign_up"><li><button className="register blue menu">Sign Up</button></li></Link>
                            </> :
                            <Link to="/dashboard"><li><button className="register blue menu">Dashboard</button></li></Link>}
                        <li>By signing up, you will have access to all our course and have the opportunity to to interact with facilitator </li>
                        <Link to="/landing_course"><li><button className="register menu">View Courses</button></li></Link>
                        <Link to="/blog"><li><button className="register menu">View Blogs</button></li></Link>
                    </div>
                </div>
            </header >
        )
    }
}

export default LandingHeader